import { render, staticRenderFns } from "./addEditCopyPackaging.vue?vue&type=template&id=347ba9e8&scoped=true&"
import script from "./addEditCopyPackaging.vue?vue&type=script&lang=ts&"
export * from "./addEditCopyPackaging.vue?vue&type=script&lang=ts&"
import style0 from "./addEditCopyPackaging.vue?vue&type=style&index=0&id=347ba9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347ba9e8",
  null
  
)

export default component.exports